import http from "../../http";

const formactivity = {
    saveFormActivity(param) {
        return http.payload("/gateway/syinfopublish/api/pc/formactivity/saveFormActivity", param)
    },
    updateFormActivity(param) {
        return http.payload("/gateway/syinfopublish/api/pc/formactivity/updateFormActivity", param)
    },
    getFormActivityDetail(param) {
        return http.get("/gateway/syinfopublish/api/pc/formactivity/getFormActivityDetail", param)
    },
    selectFormActivityPage(param) {
        return http.get("/gateway/syinfopublish/api/pc/formactivity/selectFormActivityPage", param)
    },
    deleteFormActivity(id) {
        return http.get("/gateway/syinfopublish/api/pc/formactivity/deleteFormActivity?formActivityId="+id)
    },

}
export default formactivity

